var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"space-x-4 flex flex-col items-end lg:items-start lg:flex-row leading-tight pt-1 text-base md:text-lg lg:pr-4"},_vm._l((_vm.site.menu),function(link){return _c('router-link',{key:link.uid,attrs:{"to":{ name: link.uid }}},[_vm._v(_vm._s(link.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }